<template>
  <div class="row" style="margin-bottom: 10px">
    <span class="page-title"
      >Profissional: <span>{{ user.nome }}</span></span
    >
  </div>
  <div class="row container horizontal-center">
    <!--div class="col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3  col-icon" @click="openComponent('gas')" >
            <i class="fa-solid fa-clipboard-list icons-list" ></i>
			<span >Pacientes Agendados</span>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3 col-icon" @click="openComponent('regiAt')">
            <i class="fa-solid fa-file-pen icons-list"></i>
			<span >Registrar Atendimento</span>
        </div-->
    <!--div class="col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3 col-icon" @click="openComponent('pprof')">
			<i class="fa-sharp fa-solid fa-user-doctor icons-list"></i>
			<span >Cadastro do Profissional</span>
        </div-->

    <!--
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3 col-icon">
            <i class="fa-solid fa-file-import icons-list"></i>
            <span>Gerar Documento</span>
        </div>
       -->

    <!--div class="col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3 col-icon" @click="openComponent('fb')">
            <i class="fa-solid fa-pen-to-square icons-list"></i>
            <span >Criar formulário padrão</span>
        </div-->
  </div>
  <div class="row">
    <component v-bind:is="gerirAtendimentoSecretaria" v-if="gas"></component>
    <component v-bind:is="pageRegistrarAtendimento" v-if="regiAt" :idProf="idProf"></component>
    <component v-bind:is="formBuilder" v-if="fb"></component>
    <component v-bind:is="profissionalMilitar" v-if="pprofM" :idProf="idProf"></component>
    <component v-bind:is="profissionalTerceirizado" v-if="pprofT" :idProf="idProf"></component>
  </div>
</template>

<script>
import FormBuilder from '@/components/pages/form-builder/FormBuilder';
import { getDataUser } from '@/utils';
import { getProfissionalByCpf } from '@/components/service/profissionalService';
import FormProfissionalMilitar from '@/components/pages/pages-profissional/FormProfissionalMilitar';
import FormProfissionalTerceirizado from '@/components/pages/pages-profissional/FormProfissionalTerceirizado';
import GerirAtendimentoProfissional from '@/components/pages/pages-atendimento/GerirAtendimentoProfissional';
import PageRegistrarAtendimento from '@/components/pages/pages-atendimento/PageRegistrarAtendimento';

export default {
  name: 'PageGerenciamentoProfissional',
  components: {
    GerirAtendimentoProfissional,
    FormBuilder,
    FormProfissionalMilitar,
    FormProfissionalTerceirizado,
    PageRegistrarAtendimento,
  },
  data() {
    return {
      gas: false,
      fb: false,
      ppac: false,
      pprofM: false,
      pprofT: false,
      regiAt: false,
      idProf: null,
      user: getDataUser(),
      gerirAtendimentoSecretaria: GerirAtendimentoProfissional,
      pageRegistrarAtendimento: PageRegistrarAtendimento,
      formBuilder: FormBuilder,
      profissionalMilitar: FormProfissionalMilitar,
      profissionalTerceirizado: FormProfissionalTerceirizado,
    };
  },
  methods: {
    async openComponent(value) {
      if (value === 'pprof' || value === 'regiAt') {
        this.resetComponents();
        await getProfissionalByCpf(getDataUser().cpf).then((r) => {
          this.idProf = r.data.id;
          if (value === 'pprof') {
            if (r.data.vinculo === 'MILITAR') {
              this.pprofM = true;
            } else {
              this.pprofT = true;
            }
          } else {
            this.regiAt = true;
          }
        });
      } else {
        this.resetComponents();
        switch (value) {
          case 'gas':
            this.gas = true;
            break;
          case 'fb':
            this.fb = true;
            break;
          case 'ppac':
            this.ppac = true;
            break;
          default:
            console.log('No Component');
        }
      }
    },
    resetComponents() {
      this.fb = false;
      this.gas = false;
      this.ppac = false;
      this.regiAt = false;
      this.pprofM = false;
      this.pprofT = false;
    },
  },
  created() {
    this.openComponent('regiAt');
  },
};
</script>

<style scoped>
.icons-list {
  font-size: 50px;
}

.col-icon {
  transition: transform 0.2s;
  cursor: pointer;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-content: center;
  margin: 10px;
  text-align: center;
}

.col-icon span {
  margin-top: 10px;
}
.col-icon:hover {
  transform: scale(1.1);
}

.icons-list:hover {
  color: #03315f;
  text-shadow: 0 0 3px #03315f;
}

.horizontal-center {
  margin: 0 auto;
}
</style>
